import React, { createContext, useContext, useState } from "react";
import SpinnerComponent from "../../Components/Loding/Spinner";
import { GetClienteCompleto } from "../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import { IClienteCompleto } from "../../Interfaces/Geral/Cliente/IClienteSimples";
import { TModulo } from "../../Interfaces/Utils/Modulo/ModuloInterfaces";
import { ACESSOS } from "../../Routes/Acessos";

import { HistoricoProvider } from "../Historico";

interface IClientePageProviderProps {
    children: JSX.Element | JSX.Element[];
    ID_CONTA: number;
    modulo: string;
}
interface IClientePageContext {
    Cliente: IClienteCompleto | undefined;
    modulo: Extract<TModulo, "Cobranca" | "Atendimento" | "Geral">;

    idCaso: number | undefined;
    setIdCaso: (idCaso: number) => void;
    update: () => void;
}

const ClientePageContext = createContext<IClientePageContext>(
    {} as IClientePageContext
);

export function ClientePageProvider(props: IClientePageProviderProps) {
    const {
        value: Cliente,
        loading,
        execute: update,
    } = useAsyncEffect(
        () => GetClienteCompleto(props.ID_CONTA),
        [props.ID_CONTA]
    );

    const [idCaso, setIdCaso] = useState<number>();

    const modulo =
        `/${props.modulo}` === ACESSOS.COBRANCA.DS_BASE_URL
            ? "Cobranca"
            : `/${props.modulo}` === ACESSOS.ATENDIMENTO.DS_BASE_URL
            ? "Atendimento"
            : "Geral";

    return (
        <ClientePageContext.Provider
            value={{
                Cliente,
                modulo,
                idCaso,
                setIdCaso,
                update,
            }}
        >
            {loading ? (
                <SpinnerComponent />
            ) : (
                <HistoricoProvider ID_CONTA={props.ID_CONTA}>
                    {props.children}
                </HistoricoProvider>
            )}
        </ClientePageContext.Provider>
    );
}

export function useClientePage() {
    const context = useContext(ClientePageContext);
    if (!context)
        throw new Error(
            "useClientePage necessita de um ClientePageProvider em volta do que sera utilizado"
        );

    return context;
}
